import { render, staticRenderFns } from "./difficulty.vue?vue&type=template&id=40973c6f&scoped=true&"
import script from "./difficulty.vue?vue&type=script&lang=ts&"
export * from "./difficulty.vue?vue&type=script&lang=ts&"
import style0 from "./difficulty.vue?vue&type=style&index=0&id=40973c6f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40973c6f",
  null
  
)

export default component.exports